<template>
  <!-- Navbar -->
  <nav v-if="isAuthenticated" class="main-header navbar navbar-expand navbar-white navbar-light">
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" data-widget="pushmenu" href="#" role="button">
          <i class="fas fa-bars"></i>
        </a>
      </li>
      <li class="nav-item d-none d-sm-inline-block">
        <router-link to="/" class="nav-link">Home</router-link>
      </li>
      <li class="nav-item dropdown" v-if="ifHrOperation">
        <a
          id="dropdown-tc"
          href="#"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          class="nav-link dropdown-toggle"
          >Talent & Culture</a
        >
        <ul aria-labelledby="dropdown-tc" class="dropdown-menu border-0 shadow">
          <li>
            <router-link to="/application/" class="nav-link">Application</router-link>
          </li>
        </ul>
      </li>
      <li class="nav-item dropdown" v-if="ifNotEmployee && !ifViewer">
        <a
          id="dropdown-operation"
          href="#"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          class="nav-link dropdown-toggle"
          >Operation</a
        >
        <ul aria-labelledby="dropdown-operation" class="dropdown-menu border-0 shadow">
          <li>
            <router-link to="/employee/" class="nav-link">Employees</router-link>
          </li>
          <li>
            <router-link to="/teams-admin/" class="nav-link" v-if="ifOperation"
              >Teams Admin</router-link
            >
          </li>
          <li>
            <router-link to="/tasks-admin/" class="nav-link" v-if="ifOperation"
              >Tasks Admin</router-link
            >
          </li>
        </ul>
      </li>
      <li class="nav-item dropdown">
        <a
          id="dropdown-timetracker"
          href="#"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          class="nav-link dropdown-toggle"
          >Time Tracker</a
        >
        <ul aria-labelledby="dropdown-timetracker" class="dropdown-menu border-0 shadow">
          <li v-if="!ifViewer">
            <router-link to="/time-tracker/" class="nav-link">Time Entry</router-link>
          </li>
          <li class="dropdown-divider"></li>
          <li>
            <router-link to="/time-tracker/report/" class="nav-link"
              >Detailed Report</router-link
            >
          </li>
          <li v-if="!ifViewer">
            <router-link to="/time-tracker/kpi/" class="nav-link">KPI Report</router-link>
          </li>
          <li v-if="ifNotEmployee && !ifViewer">
            <router-link to="/time-tracker/aht/" class="nav-link"
              >AHT Report</router-link
            >
          </li>
          <li v-if="ifNotEmployee && !ifViewer">
            <router-link to="/time-tracker/week-monitor/" class="nav-link"
              >Week Monitor</router-link
            >
          </li>
          <li  v-if="ifNotEmployee">
            <router-link to="/time-tracker/monitor/" class="nav-link"
              >Tasks Monitor</router-link
            >
          </li>
          <li v-if="!ifViewer">
            <router-link to="/time-tracker/quality-kpi/"
              class="nav-link"
              >Quality KPI</router-link
            >
          </li>
        </ul>
      </li>
    </ul>

    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto">
      <!-- Notifications Dropdown Menu -->
      <!-- <li class="nav-item dropdown">
        <a class="nav-link" data-toggle="dropdown" href="#">
          <i class="far fa-bell"></i>
          <span class="badge badge-warning navbar-badge">15</span>
        </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
          <span class="dropdown-item dropdown-header">15 Notifications</span>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item">
            <i class="fas fa-envelope mr-2"></i> 4 new messages
            <span class="float-right text-muted text-sm">3 mins</span>
          </a>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item">
            <i class="fas fa-users mr-2"></i> 8 friend requests
            <span class="float-right text-muted text-sm">12 hours</span> </a
          >s
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item">
            <i class="fas fa-file mr-2"></i> 3 new reports
            <span class="float-right text-muted text-sm">2 days</span>
          </a>
          <div class="dropdown-divider"></div>
          <a href="#" class="dropdown-item dropdown-footer">See All Notifications</a>
        </div>
      </li> -->
      <li class="nav-item">
        <a class="nav-link" data-widget="fullscreen" href="#" role="button">
          <i class="fas fa-expand-arrows-alt"></i>
        </a>
      </li>
      <li class="nav-item dropdown">
        <a class="nav-link" data-toggle="dropdown" href="#"> Account </a>
        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
          <a class="dropdown-item dropdown-footer">
            <router-link class="dropdown-item dropdown-footer" to="/profile/">
              Profile
            </router-link>
          </a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item dropdown-footer">
            <router-link class="dropdown-item dropdown-footer" to="/change-password/">
              Change Password
            </router-link>
          </a>
          <div class="dropdown-divider"></div>
          <a class="dropdown-item dropdown-footer">
            <button
              class="dropdown-item dropdown-footer bg-danger"
              id="sign-out"
              @click="signOut()"
            >
              Sign Out
            </button>
          </a>
        </div>
      </li>
    </ul>
  </nav>
  <!-- /.navbar -->
</template>

<script>
export default {
  components: {},
  computed: {
    isAuthenticated() {
      return this.$store.getters['users/isAuthenticated'];
    },
    ifHr() {
      const { userType } = this.$store.getters['users/userInfo'];
      const arr = ['admin', 'hr'];
      return arr.includes(userType);
    },
    ifHrOperation() {
      const { userType } = this.$store.getters['users/userInfo'];
      const arr = ['admin', 'hr', 'operation'];
      return arr.includes(userType);
    },
    ifNotEmployee() {
      const { userType } = this.$store.getters['users/userInfo'];
      return userType !== 'employee';
    },
    ifOperation() {
      const { userType } = this.$store.getters['users/userInfo'];
      const arr = ['admin', 'operation'];
      return arr.includes(userType);
    },
    ifViewer() {
      const { userType } = this.$store.getters['users/userInfo'];
      return userType === 'viewer';
    },
  },
  methods: {
    async signOut() {
      await this.$store.dispatch('users/destroyToken');
      this.$router.push('/login');
    },
    async reset() {
      await this.$store.dispatch('users/destroyToken');
      this.$router.push('/change-password');
    },
  },
};
</script>
